module.exports = __webpack_public_path__ + "static/media/Volume.2f917017.svg";